/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForExecutiveDashboardReport extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForExecutiveDashboardReport");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForExecutiveDashboardReport.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForExecutiveDashboardReport>): BackgroundJobPayloadForExecutiveDashboardReport {
        let obj = Object.assign(new BackgroundJobPayloadForExecutiveDashboardReport(), model);
        BackgroundJobPayloadForExecutiveDashboardReport.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForExecutiveDashboardReport>): BackgroundJobPayloadForExecutiveDashboardReport {
        if (!model) return null;
        return BackgroundJobPayloadForExecutiveDashboardReport.newInstance(<BackgroundJobPayloadForExecutiveDashboardReport> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForExecutiveDashboardReport) {
        if (!obj) return;

        models.BackgroundJobPayloadForExecutiveDashboardReport.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForExecutiveDashboardReport): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForExecutiveDashboardReport.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of the executive dashboard report
     */
    dashboard_report_id: string;

    /**
     * ID of the report being generated
     */
    report_id: string;

}
